import { FormElement } from './form-element.model';

export class FormElementHeader extends FormElement {
  public constructor() {
    super();

    this.intialize();
  }

  public intialize = (): void => {
    this.HeaderText = '';
    this.SubHeaderText = '';
    this.ElementTypeId = 8;
  };

  public HeaderText: string;
  public SubHeaderText: string;
}
